"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionHeader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _AccordionItem = require("../AccordionItem/AccordionItem.context");
var _Flex = require("../Flex/Flex");
var _IconChevronDown = _interopRequireDefault(require("../Icon/icons/IconChevronDown"));
var _AccordionHeader = require("./AccordionHeader.styles");
var _excluded = ["children", "onBlur", "onClick", "onFocus", "onKeyDown"];
/**
 * Interactive heading text that hides or reveals the content in its sibling
 * `Accordion.Panel`.
 *
 * @since 8.43.0
 */

var AccordionHeader = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var children = _ref.children,
    onBlur = _ref.onBlur,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    onKeyDown = _ref.onKeyDown,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_AccordionItem.AccordionItemContext),
    expanded = _useContext.expanded,
    headerId = _useContext.headerId,
    panelId = _useContext.panelId,
    ref = _useContext.ref,
    onBlurContext = _useContext.onBlur,
    onClickContext = _useContext.onClick,
    onFocusContext = _useContext.onFocus,
    onKeyDownContext = _useContext.onKeyDown;
  var innerRef = (0, _react.useCallback)(function (element) {
    if (forwardedRef) {
      if (typeof forwardedRef === 'function') {
        forwardedRef(element);
      } else {
        // eslint-disable-next-line no-param-reassign
        forwardedRef.current = element;
      }
    }
    if (ref) {
      ref(element);
    }
  }, [ref, forwardedRef]);
  var onBlurHandler = (0, _react.useCallback)(function (event) {
    onBlurContext(event);
    if (typeof onBlur === 'function') {
      onBlur(event);
    }
  }, [onBlur, onBlurContext]);
  var onClickHandler = (0, _react.useCallback)(function (event) {
    onClickContext(event);
    if (typeof onClick === 'function') {
      onClick(event);
    }
  }, [onClick, onClickContext]);
  var onFocusHandler = (0, _react.useCallback)(function (event) {
    onFocusContext(event);
    if (typeof onFocus === 'function') {
      onFocus(event);
    }
  }, [onFocus, onFocusContext]);
  var onKeyDownHandler = (0, _react.useCallback)(function (event) {
    onKeyDownContext(event);
    if (typeof onKeyDown === 'function') {
      onKeyDown(event);
    }
  }, [onKeyDown, onKeyDownContext]);
  return /*#__PURE__*/_react.default.createElement(_AccordionHeader.StyledAccordionHeader, (0, _extends2.default)({
    ref: innerRef,
    "aria-controls": panelId,
    "aria-expanded": expanded,
    id: headerId,
    tabIndex: 0,
    onBlur: onBlurHandler,
    onClick: onClickHandler,
    onFocus: onFocusHandler,
    onKeyDown: onKeyDownHandler
  }, rest), /*#__PURE__*/_react.default.createElement(_IconChevronDown.default, {
    size: "xs",
    marginRight: "sm"
  }), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexGrow: 1
  }, children));
});
exports.AccordionHeader = AccordionHeader;
AccordionHeader.displayName = 'Accordion.Header';
AccordionHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The styled-components
   * [polymorphic "as"](https://styled-components.com/docs/api#as-polymorphic-prop) prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any,
  children: _propTypes.default.node.isRequired,
  /**
   * @ignore
   */
  onBlur: _propTypes.default.func,
  /**
   * @ignore
   */
  onClick: _propTypes.default.func,
  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,
  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,
  /**
   * A [role](https://www.w3.org/TR/wai-aria-1.2/#roles) is required for assistive
   * technologies to announce the header properly. Header uses the
   * [button](https://www.w3.org/TR/wai-aria-1.2/#region) role.
   */
  role: _propTypes.default.string
} : {};
AccordionHeader.defaultProps = {
  role: 'button'
};